import TextInput from './TextInput';
import './TextInput.scss';

export default TextInput;